import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function NotFound() { 
  return (
    <Box sx={{
      p: 3,
      alignSelf:"center",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      display: "flex"
    }}>
      <Box sx={{
        maxWidth: "600px",
        alignSelf:"center",
        display: "inline-block"
      }}>
          <Typography component="p" variant="h1" sx={{ color: 'text.dark' }}>Not Found</Typography>
          <Typography component="p" variant="h2" sx={{ color: 'text.dark' }}>Page Not Found</Typography>
      </Box>
    </Box>
  );
}

